import React, { useCallback, useContext, useEffect } from 'react'
import { AutocompleteContainer } from '../../Components/Search'
import { PageContainerMain, Box } from '../../Components/Layout'
import { PageHeader } from '../../Components/Headers'
import { MatchupContext } from '../../Context'
import { MatchupTabs } from './components/Tabs/MatchupTabs'
import { GameInfo } from './components/gameInfo/GameInfo'
import { Loading } from '../Loading'
import { colors } from '../../Components/consts'
import { DarkCon } from './styles'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { HelmetProvider } from 'react-helmet-async'
import { SEOTags } from '../../Components/SEO/SEOTags'
import { EventGQL } from '../../Api'
import { generateMatchupSEOTags } from '../../Utils'

const Matchup: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { eventInfo, isLoading, banners } = useContext(MatchupContext)!

  useEffect(() => {
    if (!eventInfo || isLoading) return
  }, [eventInfo, isLoading])

  const getSEOTags = useCallback(
    (tag: 'title' | 'description' | 'keywords', eventInfo: EventGQL | null) => {
      const generatedTags = generateMatchupSEOTags(eventInfo)
      return generatedTags[tag]
    },
    [eventInfo]
  )

  return (
    <HelmetProvider>
      <SEOTags
        title={getSEOTags('title', eventInfo)}
        description={getSEOTags('description', eventInfo)}
        keywords={getSEOTags('keywords', eventInfo)}
      />
      <PageContainerMain backgroundColor={colors.darkBackground}>
        <DarkCon>
          {banners && (
            <PageHeader banner={banners} img={banners.topUrl} link={banners.topLink} />
          )}
          <AutocompleteContainer />
          <AdUnit bannerType="bannerMain" aria-label="Matchup page ad" />
          <Box boxColor="grey">
            {eventInfo ? <GameInfo eventInfo={eventInfo} /> : <div />}
          </Box>
          {isLoading ? <Loading /> : <MatchupTabs />}
        </DarkCon>
      </PageContainerMain>
    </HelmetProvider>
  )
}

export default Matchup
